import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'material-design-lite/material.css';
import 'material-design-lite/material.js';
import 'getmdl-select/getmdl-select.min.css';
import 'getmdl-select/getmdl-select.min.js';
import './index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/